import { apiFetch } from './client.ts';
import type { CompactPuzzle } from '@ricochet/game-engine';
import type { Unlock } from '@ricochet/achievements';

export interface InitSpeedrunResponse {
  initToken: string;
  startedAt: number;
  pbPuzzleTimes: number[] | null;
}

export interface BindSpeedrunResponse {
  sessionToken: string;
  startedAt: number;
}

export interface StartSpeedrunResponse {
  token: string;
  startedAt: number;
}

export interface FinishSpeedrunResponse {
  totalTimeMs: number;
  isNewBest: boolean;
  leaderboardRank: number;
  pbPuzzleTimes: number[] | null;
  unlockedAchievements: Unlock[];
}

export function initSpeedrun(token: string): Promise<InitSpeedrunResponse> {
  return apiFetch('/api/speedrun/init', {
    method: 'POST',
    body: {},
    token,
    timeoutMs: 15000,
  });
}

export function bindSpeedrun(
  token: string,
  initToken: string,
  puzzles: CompactPuzzle[],
): Promise<BindSpeedrunResponse> {
  return apiFetch('/api/speedrun/bind', {
    method: 'POST',
    body: { initToken, puzzles },
    token,
    timeoutMs: 15000,
  });
}

export function startSpeedrun(puzzles: CompactPuzzle[], token: string): Promise<StartSpeedrunResponse> {
  return apiFetch('/api/speedrun/start', {
    method: 'POST',
    body: { puzzles },
    token,
    timeoutMs: 15000,
  });
}

export function finishSpeedrun(
  token: string,
  sessionToken: string,
  puzzles: CompactPuzzle[],
  solutions: string[],
  puzzleTimes: number[],
): Promise<FinishSpeedrunResponse> {
  return apiFetch('/api/speedrun/finish', {
    method: 'POST',
    body: { token: sessionToken, puzzles, solutions, puzzleTimes },
    token,
    timeoutMs: 15000,
  });
}

export { getSpeedrunLeaderboard } from './leaderboard.ts';
